import { render } from "./sidebar.vue?vue&type=template&id=284456da&scoped=true"
import script from "./sidebar.vue?vue&type=script&lang=js"
export * from "./sidebar.vue?vue&type=script&lang=js"

import "./sidebar.vue?vue&type=style&index=0&id=284456da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-284456da"]])

export default __exports__